import _toConsumableArray from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _createForOfIteratorHelper from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _slicedToArray from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var e = Symbol(),
    t = Symbol(),
    r = "a",
    n = "w";

var o = function o(e, t) {
  return new Proxy(e, t);
};

var s = Object.getPrototypeOf,
    c = new WeakMap(),
    l = function l(e) {
  return e && (c.has(e) ? c.get(e) : s(e) === Object.prototype || s(e) === Array.prototype);
},
    f = function f(e) {
  return "object" == typeof e && null !== e;
},
    i = function i(e) {
  if (Array.isArray(e)) return Array.from(e);
  var t = Object.getOwnPropertyDescriptors(e);
  return Object.values(t).forEach(function (e) {
    e.configurable = !0;
  }), Object.create(s(e), t);
},
    u = function u(e) {
  return e[t] || e;
},
    a = function a(s, c, f, p) {
  if (!l(s)) return s;
  var g = p && p.get(s);

  if (!g) {
    var _e = u(s);

    g = function (e) {
      return Object.values(Object.getOwnPropertyDescriptors(e)).some(function (e) {
        return !e.configurable && !e.writable;
      });
    }(_e) ? [_e, i(_e)] : [_e], null == p || p.set(s, g);
  }

  var _g = g,
      _g2 = _slicedToArray(_g, 2),
      y = _g2[0],
      h = _g2[1];

  var w = f && f.get(y);
  return w && w[1].f === !!h || (w = function (o, s) {
    var c = {
      f: s
    };
    var l = !1;

    var f = function f(e, t) {
      if (!l) {
        var _s = c[r].get(o);

        if (_s || (_s = {}, c[r].set(o, _s)), e === n) _s[n] = !0;else {
          var _r = _s[e];
          _r || (_r = new Set(), _s[e] = _r), _r.add(t);
        }
      }
    },
        i = {
      get: function get(e, n) {
        return n === t ? o : (f("k", n), a(Reflect.get(e, n), c[r], c.c));
      },
      has: function has(t, n) {
        return n === e ? (l = !0, c[r].delete(o), !0) : (f("h", n), Reflect.has(t, n));
      },
      getOwnPropertyDescriptor: function getOwnPropertyDescriptor(e, t) {
        return f("o", t), Reflect.getOwnPropertyDescriptor(e, t);
      },
      ownKeys: function ownKeys(e) {
        return f(n), Reflect.ownKeys(e);
      }
    };

    return s && (i.set = i.deleteProperty = function () {
      return !1;
    }), [i, c];
  }(y, !!h), w[1].p = o(h || y, w[0]), f && f.set(y, w)), w[1][r] = c, w[1].c = f, w[1].p;
},
    p = function p(e, t, r, o) {
  if (Object.is(e, t)) return !1;
  if (!f(e) || !f(t)) return !0;
  var s = r.get(u(e));
  if (!s) return !0;

  if (o) {
    var _r2 = o.get(e);

    if (_r2 && _r2.n === t) return _r2.g;
    o.set(e, {
      n: t,
      g: !1
    });
  }

  var c = null;

  try {
    var _iterator = _createForOfIteratorHelper(s.h || []),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _r4 = _step.value;
        if (c = Reflect.has(e, _r4) !== Reflect.has(t, _r4), c) return c;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    if (!0 === s[n]) {
      if (c = function (e, t) {
        var r = Reflect.ownKeys(e),
            n = Reflect.ownKeys(t);
        return r.length !== n.length || r.some(function (e, t) {
          return e !== n[t];
        });
      }(e, t), c) return c;
    } else {
      var _iterator2 = _createForOfIteratorHelper(s.o || []),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _r3 = _step2.value;
          if (c = !!Reflect.getOwnPropertyDescriptor(e, _r3) != !!Reflect.getOwnPropertyDescriptor(t, _r3), c) return c;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }

    var _iterator3 = _createForOfIteratorHelper(s.k || []),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _n = _step3.value;
        if (c = p(e[_n], t[_n], r, o), c) return c;
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    return null === c && (c = !0), c;
  } finally {
    o && o.set(e, {
      n: t,
      g: c
    });
  }
},
    g = function g(t) {
  return !!l(t) && e in t;
},
    y = function y(e) {
  return l(e) && e[t] || null;
},
    h = function h(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
  c.set(e, t);
},
    w = function w(e, t, r) {
  var o = [],
      s = new WeakSet(),
      c = function c(e, l) {
    if (s.has(e)) return;
    f(e) && s.add(e);
    var i = f(e) && t.get(u(e));

    if (i) {
      var a, p;

      if (null == (a = i.h) || a.forEach(function (e) {
        var t = ":has(".concat(String(e), ")");
        o.push(l ? [].concat(_toConsumableArray(l), [t]) : [t]);
      }), !0 === i[n]) {
        var _e2 = ":ownKeys";
        o.push(l ? [].concat(_toConsumableArray(l), [_e2]) : [_e2]);
      } else {
        var g;
        null == (g = i.o) || g.forEach(function (e) {
          var t = ":hasOwn(".concat(String(e), ")");
          o.push(l ? [].concat(_toConsumableArray(l), [t]) : [t]);
        });
      }

      null == (p = i.k) || p.forEach(function (t) {
        r && !("value" in (Object.getOwnPropertyDescriptor(e, t) || {})) || c(e[t], l ? [].concat(_toConsumableArray(l), [t]) : [t]);
      });
    } else l && o.push(l);
  };

  return c(e), o;
},
    O = function O(e) {
  o = e;
};

export { w as affectedToPathList, a as createProxy, y as getUntracked, p as isChanged, h as markToTrack, O as replaceNewProxy, g as trackMemo };